const HN = {
  // Currency
  currency: "SAR",

  // Buttons Labels Repeated
  "modal-ok-btn": "ठीक है",
  "send-btn": "भेजना",
  "cancel-btn": "रद्द करना",

  // ==========================================================================================================================================
  // Error Messages
  "phone-number-error": "कृपया एक फ़ोन नंबर दर्ज करें",
  "password-error": "अपना पासवर्ड दर्ज करें",
  "confirm-password-error": "कृपया पासवर्ड की पुष्टि करें",
  "user-name-error": "अपने उपयोगकर्ता नाम दर्ज करें",
  "confirm-code-error": "कृपया कोड दर्ज करें",

  // Input Error Messages
  "user-name-input-error":
    "कृपया सुनिश्चित करें कि दर्ज किया गया उपयोगकर्ता नाम सही है",
  "phone-number-input-error":
    "कृपया सुनिश्चित करें कि दर्ज किया गया फ़ोन नंबर सही है",
  "password-input-error":
    "कृपया सुनिश्चित करें कि दर्ज किया गया पासवर्ड सही है",
  "confirm-password-input-error": "कृपया पासवर्ड की सही पुष्टि करें",
  // ==========================================================================================================================================
  // Navbar
  "arabic-key": "अरबी",
  "english-key": "अंग्रेज़ी",
  "urdu-key": "उर्दू",
  "hindi-key": "हिन्दी",
  "main-tab": "मुख्य",
  "notification-tab": "सूचनाएं",
  "orders-tab": "ट्रैक आदेश",
  "settings-tab": "समायोजन",
  "user-name": "उपयोगकर्ता नाम",
  "sign-out": "साइन आउट",
  // ==========================================================================================================================================
  // StartUp
  "Startup-form-header": "अपना सामान साफ ​​करो",
  "Startup-box-text-1":
    "क्या आपके पास बहुत सी चीजें हैं जिन्हें साफ करने की जरूरत है?",
  "Startup-box-text-2":
    "आराम करें और अपनी जरूरत की हर चीज को साफ करने के लिए हमें कॉल करें",
  "Startup-box-text-3": "आप किस का इंतजार कर रहे हैं? हमसे अभी जुड़ो",
  "Lets-start-btn": "चलो शुरू करते हैं",

  // Copy Rights Start
  "copy-rights-start-1": "कोई सवाल है?",
  "copy-rights-start-2": "संपर्क करें",
  "copy-rights-start-3": "सफाई सेवा ऐप",
  "copy-rights-start-4": "| सर्वाधिकार सुरक्षित",
  "copy-rights-start-5": "स्टैक सॉफ्ट कंपनी द्वारा विकसित",

  // ==========================================================================================================================================
  // LogIn
  "login-form-header": "लॉग इन करें",
  "login-phone-number-label": "फ़ोन नंबर",
  "login-phone-number-text":
    "हम कभी भी आपका फ़ोन नंबर किसी और के साथ साझा नहीं करेंगे।",
  "login-phone-number-placeholder": "फ़ोन नंबर",
  "login-password-label": "पासवर्ड",
  "login-password-placeholder": "पासवर्ड",
  "login-btn-text": "लॉग इन करें",
  "login-no-account-text": "अब तक कोई खाता नहीं है?",
  "login-no-account-signup": "साइन अप करें",
  "login-method-text": "या लॉग इन करें",
  "login-method-1-text": "Google",
  "login-method-2-text": "Apple",

  // ==========================================================================================================================================
  // SignUp
  "signup-form-header": "साइन अप करें",
  "confirm-signup-form-header": "सत्यापन चरण",
  "confirm-signup-please-input-code": "कृपया सत्यापन कोड दर्ज करें",
  "confirm-signup-code-is-sent-to": "कोड नंबर पर भेज दिया गया है: ",
  "confirm-signup-ask-if-receive-code": "कोड नहीं मिला? ",
  "confirm-signup-re-send-code": "पुन: ट्रांसमीटर",
  "confirm-signup-verify-code": "सत्यापन",
  "confirm-signup-close-code": "बंद करना",
  "signup-phone-number-text":
    "हम कभी भी आपका फ़ोन नंबर किसी और के साथ साझा नहीं करेंगे।",
  "signup-phone-number-placeholder": "फ़ोन नंबर",
  "signup-user-name-placeholder": "असल में",
  "building-number": "निर्माण संख्या",
  "floor-number": "मंजिल संख्या",
  "signup-password-placeholder": "पासवर्ड",
  "signup-password-confirm-placeholder": "पासवर्ड की पुष्टि कीजिये",
  "signup-btn-text": "साइन अप करें",
  "signup-method-text": "या के साथ साइन अप करें",
  "signup-method-1-text": "Google",
  "signup-method-2-text": "Apple",

  // ==========================================================================================================================================
  // Main
  // Main Navbar
  "search-main-tab": "एक लॉन्ड्रोमैट खोजें",
  "fav-main-tab": "पसंदीदा",
  "recently-main-tab": "हाल ही में उपयोग किया गया",
  "request-main-tab": "सेवा अनुरोध",

  // ==========================================================================================================================================
  // Search Washer
  "Search-box-placeholder": "नाम से खोजें...",
  "laundry-location-label-card": "लॉंड्रामेट स्थान: ",
  "rate-filter-search-washer": "सर्वाधिक श्रेणीकृत",
  "near-filter-search-washer": "निकटतम",
  "rate-max-to-min": "सबसे ज्यादा रेटिंग से लेकर सबसे कम रेटिंग तक",
  "rate-min-to-max": "कम से कम मूल्यांकन से लेकर अधिकांश तक",
  "choose-city": "कोई शहर चुनें",
  "sort-starting-with": "से छाँटें",
  "discount-label": "छूट",
  "free-deliver-label": "नि: शुल्क डिलिवरी",
  "no-laundromats": "अभी तक कोई लॉन्ड्री नहीं है",

  // ==========================================================================================================================================
  // Laundry Modal
  "laundry-services-label": "लॉंड्रामेट सेवाएँ: ",
  "request-service-button": "सेवा अनुरोध",
  "move-to-map-button": "मानचित्र पर ले जाएँ",
  "services-laundry-table-column": "सेवाऍ दी गयी",
  "size-laundry-table-column": "सेवारत आकार",

  // ==========================================================================================================================================
  // Service Request
  "choose-type": "विजेट प्रकार चुनें",
  "choose-type-first": "पहले विजेट प्रकार चुनें",
  "check-box-take-your-order":
    "आपका ऑर्डर लेना और उसे हमारे डिलीवरी प्रतिनिधियों के माध्यम से हमें वापस करना",
  "choose=service-type-select-option": "सेवा का प्रकार चुनें",
  "send-request-service": "अनुरोध भेजा",
  "specify-current-location": "अपने वर्तमान स्थान का चयन करें:",
  "span-under-location-row":
    "*ग्राहक की आप तक पहुंच को सुविधाजनक बनाने के लिए आपके वर्तमान स्थान निर्देशांक स्वचालित रूप से ले लिए जाएंगे",
  "no-services-yet": "कोई अन्य सेवाएं नहीं हैं",
  "price-after-discount": "डिस्काउंट के बाद कीमत:",
  "price-after-free-delivery": "डिलीवरी शुल्क काटने के बाद कीमत:",

  // ==========================================================================================================================================
  // Settings
  // Settings Navbar
  "password-settings-tab": "सिस्टम का काम",
  "user-info-settings-tab": "उपयोगकर्ता जानकारी",
  "location-settings-tab": "स्थान",
  "Terms-Conditions-settings-tab": "नियम और शर्तें",
  "system-work-settings-tab": "तंत्र कार्य",
  // ==========================================================================================================================================
  // System Change Password
  "system-user-name-change-label": "उपयोगकर्ता नाम",
  "system-phone-change-label": "फ़ोन नंबर",
  "system-old-password-change-label": "पुराना पासवर्ड",
  "system-password-change-label": "नया पासवर्ड",
  "system-confirm-password-change-label": "नए पासवर्ड की पुष्टि करें",
  "system-password-btn-change-label": "पुष्टि करें",
  // ==========================================================================================================================================
  // System Change Location
  "system-location-change-label": "आपके वर्तमान स्थान",
  "system-location-change-note":
    "यदि आप स्थान को मैन्युअल रूप से सेट करते हैं, तो कृपया इसे सटीक रूप से निर्दिष्ट करें",
  "system-location-btn-auto-label": "स्थान को स्वचालित रूप से सेट करें",
  "system-location-btn-change-label": "पुष्टि करें",
  // ==========================================================================================================================================
  // System Work
  Bronze: "पीतल",
  Silver: "चाँदी",
  Gold: "सोना",
  Diamond: "हीरा",

  // ==========================================================================================================================================
  // Notifications
  // Notifications Texts
  "Laundry-Accept": "आपका लॉन्ड्री ऑर्डर स्वीकार कर लिया गया है",
  "Laundry-Reject": "आपके कपड़े धोने के आदेश को अस्वीकार कर दिया गया है",
  "Delivery-Accept": "आपका अनुरोध वितरण से प्राप्त हो गया है",
  "Laundry-Received-order":
    "आपका आदेश लॉन्ड्रोमैट पर पहुंच गया है और जब यह हो जाएगा तो हम आपको सूचित करेंगे",
  "Laundry-start-washing-notification": "आपका आदेश विवरण हैं",
  "Laundry-finish-washing-ready-Delivering": "आपका अनुरोध पूरा हो गया है",
  "Free-Delivery-notif": "",
  "Discount-notif": "",
  "Delivered-state": "आपका अनुरोध सफलतापूर्वक वितरित कर दिया गया है",
  "order-num-notification": "क्रम संख्या: ",
  "rate-send-notification": "आपका अनुभव कैसा रहा? ",
  "note-send-notification": "आपकी प्रतिक्रिया क्या है? ",

  // Notifications Table details
  "item-type-column-notification": "वस्तु परक",
  "service-type-column-notification": "सेवा प्रकार",
  "number-of-items-column-notification": "वस्तुओ की संख्या",
  "price-column-notification": "कीमत",

  // ==========================================================================================================================================
  // Orders
  // Orders Navbar
  "my-orders-nav": "मेरे आदेश",
  "done-orders-nav": "मेरे समाप्त आदेश",

  // Order Statuses
  "Waiting-Laundry-Accept": "लंबित फुटकर स्वीकृति",
  "Waiting-Delivery-Accept": "वितरण स्वीकृति लंबित",
  "Delivery-Taking-Order-from-user": "क्लाइंट से लाया जा रहा है",
  "Delivery-Taking-Order-to-Laundry": "लॉन्ड्री लाया जा रहा है",
  "Waiting-Laundry-start-washing": "पूर्व-संसाधन",
  "Laundry-start-washing": "संसाधित कर रहा है",
  "Ready-to-Deliver": "वितरित करने के लिए तैयार है",
  "Waiting-Delivery-Taking-Accept": "प्रदेय वितरण स्वीकृति",
  "Delivery-ReturnBack-Order-from-Laundry": "लॉन्ड्री से लाया जा रहा है",
  "Delivery-ReturnBack-Order-to-user": "क्लाइंट में लाया जा रहा है",
  "Delivered-order-to-user": "हो गया",

  // Order Labels
  "Laundry-name-label-order": "लॉंड्रामेट नाम: ",
  "Delivery-name-label-order": "प्रतिनिधि का नाम: ",
  "Date-label-order": "तिथि निर्माण: ",
  "Type-label-order": "आदेश प्रकार: ",
  "details-name-btn-order": "ऑर्डर का विवरण",

  // Order Details Modal and Table
  "item-type-column": "वस्तु परक",
  "service-type-column": "सेवा प्रकार",
  "number-of-items-column": "वस्तुओ की संख्या",
  "price-column": "कीमत",
  "price-label-modal": "कुल कीमत: ",
  "price-cost-label-modal": "लागत: ",
  "price-commission-label-modal": "आयोग: ",

  // delivering Orders Types
  "delivery-two-ways": "यह प्रतिनिधियों द्वारा लिया और दिया जाता है",
  "delivery-one-way": "प्रतिनिधियों द्वारा ही लिया गया",

  // ==========================================================================================================================================

  // Contact Us

  // ******  Headers
  "contactUs-header": "Contact Us",
  "first-contactUs-header": "Contact Information",
  "second-contactUs-header": "Leave Us a message",

  // ******  Communicate Column
  "location-communicate-label": "Address",
  "location-communicate-value": "Jordan Jordan Jordan",
  "phone-communicate-label": "Phone",
  "phone-communicate-value": "0999999999",
  "email-communicate-label": "E-mail Address",
  "email-communicate-value": "example@gmail.com",

  // ******  send message Column
  "name-label": "Name",
  "name-placeholder": "your name",
  "email-send-message-label": "E-mail Address",
  "email-send-message-placeholder": "example@gmail.com",
  "message-contactUs-label": "Message",
  "message-contactUs-placeholder": "what do you want to tell us ?",
  "button-send-message-contactUs": "Send",

  // ==========================================================================================================================================
};

export default HN;
